import axios, { AxiosResponse } from 'axios';
import { ApiMenuReadResponse } from '@/venit/services/model/techpubs-cms';

export default class ApiMenuService {
  public read(menuId: number, lang: string, page: number, pageSize: number): Promise<AxiosResponse<ApiMenuReadResponse>> {
    return axios.get<ApiMenuReadResponse>(`/api/v1/menu/${menuId}?lang=${lang}&page=${page}&pageSize=${pageSize}`);
  }

  public readAdmin(menuId: number, lang: string, page: number, pageSize: number): Promise<AxiosResponse<ApiMenuReadResponse>> {
    return axios.get<ApiMenuReadResponse>(`/api/v1/menu/${menuId}/admin?lang=${lang}&page=${page}&pageSize=${pageSize}`);
  }
}
